// extracted by mini-css-extract-plugin
export default {"container":"l1k9E6","description":"CadOIh","checkboxContainer":"ueiuQ0","alert":"MnIhpi","sectionNotificationContainer":"dOlvOn","labelContainer":"nqtZhG","error":"DzQtBL"};